import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class Globals {
  public static apiHost: string;
  public static socketHost: string;
}